import { render, staticRenderFns } from "./PdfToImg.vue?vue&type=template&id=6cff6373&scoped=true"
import script from "./PdfToImg.vue?vue&type=script&lang=js"
export * from "./PdfToImg.vue?vue&type=script&lang=js"
import style0 from "./PdfToImg.vue?vue&type=style&index=0&id=6cff6373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff6373",
  null
  
)

export default component.exports